import { Outlet, createRootRouteWithContext } from "@tanstack/react-router"
import type { QueryClient } from "@tanstack/react-query"
import type { auth as authT } from "@/lib/auth"

interface RouterContext {
  queryClient: QueryClient
  auth: typeof authT
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => <Outlet />,
})
